var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScribble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3546_8326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.81206 1.22812C6.32769 0.759375 6.99956 0.5 7.69644 0.5H7.73081C9.25894 0.5 10.4996 1.74062 10.4996 3.26875C10.4996 4.00312 10.2089 4.70625 9.69019 5.225L3.72456 11.1906C3.58081 11.3344 3.49956 11.5312 3.49956 11.7344C3.49956 12.1562 3.84331 12.5 4.26831 12.5C4.47144 12.5 4.66831 12.4187 4.81206 12.275L11.7746 5.30937C12.2933 4.79062 12.9964 4.5 13.7308 4.5C15.2589 4.5 16.4996 5.74063 16.4996 7.26875C16.4996 8.00313 16.2089 8.70625 15.6902 9.225L12.9339 11.9812C12.6589 12.2562 12.5027 12.6344 12.5027 13.025C12.5027 13.8375 13.1621 14.4969 13.9714 14.4969C14.1652 14.4969 14.3589 14.45 14.5339 14.3656L15.0558 14.1031C15.5496 13.8562 16.1496 14.0563 16.3964 14.55C16.6433 15.0437 16.4433 15.6438 15.9496 15.8906L15.4246 16.1562C14.9714 16.3813 14.4746 16.5 13.9683 16.5C12.0496 16.5 10.4996 14.9406 10.4996 13.0281C10.4996 12.1062 10.8652 11.2219 11.5183 10.5688L14.2746 7.8125C14.4183 7.66875 14.4996 7.47188 14.4996 7.26875C14.4996 6.84375 14.1558 6.5 13.7308 6.5C13.5277 6.5 13.3308 6.58125 13.1871 6.725L6.22456 13.6906C5.70581 14.2094 5.00269 14.5 4.26831 14.5C2.74019 14.5 1.49956 13.2594 1.49956 11.7312C1.49956 10.9969 1.79019 10.2937 2.30894 9.775L8.27456 3.80938C8.41831 3.66563 8.49956 3.46875 8.49956 3.26562C8.49956 2.84375 8.15581 2.5 7.73081 2.5H7.69644C7.49644 2.5 7.30269 2.575 7.15581 2.70937L2.17144 7.24062C1.76206 7.6125 1.13081 7.58125 0.758938 7.17188C0.387063 6.7625 0.418313 6.13125 0.827688 5.75938L5.81206 1.22812Z",
    fill: "#61A1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3546_8326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScribble);
export default __webpack_public_path__ + "static/media/Scribble.212b74554017ea1fbf2a663fbc2777c7.svg";
export { ForwardRef as ReactComponent };